import React, { useEffect, useRef, useState } from "react"
import PropTypes from "prop-types"
import { Button } from "antd"
import { useTranslation } from "react-i18next"
import styles from "./ReadMoreText.module.css"

// A description that, on a phone (Figma 6058:142202), shows its first lines with "Read More" /
// "Read Less" below. The button only appears when the text is longer than those lines; on wider
// screens the whole text shows.
const ReadMoreText = ({ text, className }) => {
  const { t } = useTranslation()
  const textRef = useRef(null)
  const [isExpanded, setIsExpanded] = useState(false)
  const [isClamped, setIsClamped] = useState(false)

  useEffect(() => {
    const element = textRef.current
    if (!element || typeof ResizeObserver === "undefined") return undefined
    const measure = () => setIsClamped(element.scrollHeight - element.clientHeight > 1)
    measure()
    const observer = new ResizeObserver(measure)
    observer.observe(element)
    return () => observer.disconnect()
  }, [text, isExpanded])

  return (
    <div>
      <p ref={textRef} className={`${styles.text} ${isExpanded ? "" : styles.clamped} ${className || ""}`}>
        {text}
      </p>
      {(isClamped || isExpanded) && (
        <Button type="link" className={styles.toggle} aria-expanded={isExpanded} onClick={() => setIsExpanded(!isExpanded)}>
          {isExpanded ? t("booking_widget.experience.read_less") : t("booking_widget.experience.read_more")}
        </Button>
      )}
    </div>
  )
}

ReadMoreText.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string
}

ReadMoreText.defaultProps = {
  className: ""
}

export default ReadMoreText
